{
  "nl": {
    "modal": {
      "actions": {
        "add": "Wijs deze klant aan deze unit toe",
        "approve": "Aanvaarden",
        "assign": "Toewijzen",
        "assign_SUP": "Toewijzen aan dit project",
        "block": "Blokkeer",
        "cancel": "Annuleer",
        "close": "Sluit",
        "contact_ziggu": "Contacteer Ziggu",
        "deactivate": "Deactiveren",
        "giveAccess": "Geef online toegang",
        "goBack": "Ga terug",
        "gotIt": "Oké",
        "loading": "Laden",
        "next": "Volgende",
        "no": "Nee",
        "reactivate": "Reactiveren",
        "remove": "Verwijderen",
        "select_rights": "Selecteer rechten",
        "send": "Ja",
        "sendFeedback": "Feedback sturen",
        "submit": "Opslaan",
        "submitting": "Laden",
        "uploading": "Opladen",
        "yes": "Ja"
      },
      "labels": {
        "areYouSure": "Ben je zeker?",
        "areYouSureDelete": "Weet je zeker dat je {object} wilt verwijderen?",
        "assignCustomerToUnitMessagePermanently": "{customer} is al uitgenodigd op het platform. Door deze unit toe te wijzen, heeft de klant directe toegang.",
        "assignCustomerToUnitTitlePermanently": "Wijs {customer} onmiddelijk toe aan {unit}?",
        "assignTodoListToLevel": "Je staat op het punt de takenlijst {object} toe te wijzen aan niveau {level}. Doorgaan?",
        "dangerZone": "Gevarenzone",
        "deactivate": "Ben je zeker dat je {contact} wil deactiveren?",
        "deactivateMessage": "De gebruiker krijgt geen toegang meer tot het platform. Alle documenten, faqs, aankondigingen, taken, tickets, enz. gerelateerd aan deze gebruiker blijven toegankelijk op het platform voor andere gebruikers.",
        "deleteCustomerMessage": "Deze persoon verliest alle toegang tot het platform en dus alle documenten, veelgestelde vragen, gesprekken, nieuwsberichten, enz.",
        "deleteCustomerTitle": "Ben je zeker dat je {customer} wil verwijderen?",
        "deleteDecisionsBulk": "Ben je zeker dat je {amount} beslissingen wilt verwijderen?",
        "deleteDeniedMessage": "Deze klant heeft ten minste 1 unit aan hem/haar toegewezen. Verwijder eerst alle toegewezen units voordat je deze klant verwijdert.",
        "deleteDeniedTitle": "Verwijderen niet toegestaan",
        "deleteEmployeeIntercom": "Neem contact met ons op via Intercom en wij helpen je meteen!",
        "deleteEmployeeMessage": "Deze gebruiker zal alle toegang tot het platform verliezen. Alle documenten, tickets en aankondigingen met betrekking tot deze gebruiker worden ook verwijderd.",
        "deleteEmployeeQuestion": "Liever verwijderen?",
        "deleteEmployeeSubMessage": "Deactiveer deze gebruiker in de plaats als je al zijn of haar gegevens wil behouden.",
        "deleteEmployeeTitle": "Ben je zeker dat je {employee} wil verwijderen?",
        "deleteLeadMessage": "Als deze lead geïnteresseerd was in een unit, verliest u deze gegevens. Als de lead een unit heeft gekocht en klant is geworden, worden de klant en zijn gegevens behouden.",
        "deleteLeadTitle": "Weet u zeker dat u lead {lead} wilt verwijderen?",
        "goToProposal": "Ga naar {proposal_name}",
        "gotItMessage": "Ok, begrepen",
        "loading": "Bestand wordt geüpload, even geduld aub. Het uploadscherm wordt automatisch gesloten.",
        "noUnitSelected": "Uh oh! Geen woning geselecteerd",
        "noUnitSelectedMessage": "Selecteer het apparaat waarvoor je een defect wilt melden",
        "notPossible": "Niet mogelijk",
        "ohNo": "Oh nee!",
        "reactivate": "Ben je zeker dat je {contact} wil reactiveren",
        "reactivateMessage": "De gebruiker zal opnieuw toegang hebben tot het platform.",
        "removeCustomerDeleteInfo1": "Gesprekken waaraan de klant heeft deelgenomen, worden verwijderd",
        "removeCustomerDeleteInfo2": "Enquêtes met betrekking tot deze unit worden verwijderd",
        "removeCustomerDeleteInfo3": "Documenten die door de klant zijn geüpload in gesprekken, beslissingen of voorstellen, worden verwijderd. Dit omvat ook ondertekende versies van documenten.",
        "removeCustomerKeepInformation": "Algemene documenten en alle andere gerelateerde zaken die naar deze unit worden gepubliceerd, blijven ongewijzigd en zijn zichtbaar voor een nieuwe klant.",
        "removeCustomerMessage": "{customer} had volledige toegang tot deze unit. Als je de klant verwijdert, wordt alle inhoud van {customer} verwijderd. Dit betekent ...",
        "removeCustomerMessageNth": "Als u deze klant verwijdert, wordt de inhoud die door {customer} is gemaakt, losgekoppeld van {customer}. Dat betekent dat de inhoud behouden blijft, maar niet meer afkomstig is van {customer}.",
        "removeMessage": "Ben je zeker dat je {level} wil verwijderen? Je verliest ALLE data gekoppeld aan dit project. Je kan deze data achteraf niet meer terughalen.",
        "removeTitle": "Verwijder {record_name}",
        "revokeAccessMessage": "Je staat op het punt de toegang van {customer} tot deze unit in te trekken. Als dit de enige toegewezen unit is, verliest de klant de volledige toegang tot het platform.",
        "setCustomerMessage": "Prima! Je staat op het punt om klant {customer} toe te wijzen aan {unit}, maar {customer} zal nog geen toegang hebben tot deze unit. Je kan na het toewijzen de klant ook uitnodigen.",
        "setCustomerMessageSUP": "Geweldig! Je staat op het punt om {customer} toe te wijzen aan {unit}. {customer} heeft echter nog geen volledige toegang tot het platform. Maar dat kun je veranderen door toegang te verlenen zodra je dit project hebt toegewezen. ",
        "setCustomerTitle": "{customer} toewijzen aan {unit}?",
        "setVisibleMessage": "{customer} zal toegang krijgen tot alle documenten en informatie gelinkt aan deze unit.",
        "setVisibleTitle": "{customer} online toegang geven tot {unit}?",
        "this": "dit",
        "typeHere": "Typ hier...",
        "typeToConfirm": "Typ \"{confirmationInput}\" om te bevestigen",
        "warningAreYouSure": "VOORZICHTIG! Weet je het zeker?",
        "warningDeleteDocument": "{file_name} werd geüpload in een {attachable_type}. Als je het hier verwijdert, zal het ook verwijderd worden in de {attachable_type}",
        "warningDeleteDocumentApprovedProposal": "{file_name} is een document dat hoort bij een goedgekeurd voorstel en kan in deze staat niet worden verwijderd. Als u het wilt verwijderen, moet de goedkeuring van het voorstel worden teruggedraaid",
        "warningDeleteDocumentLevel": "{file_name} werd geüpload in de {level_type} folder. Als je het hier verwijdert, zal het ook verwijderd worden in de {level_type} folder",
        "warningDeleteDocumentMulti": "Sommige van de documenten die je wilt verwijderen, zijn geüpload in een beslissing of een gesprek. Als je ze hier verwijdert, worden ze ook verwijderd uit de beslissing of het gesprek"
      }
    }
  }
}
